<template>
    <div class="functionListDiv">
        <div class="functionListTab">
            <Tabs :value="Tab.CurrentName" :animated="true">
                <TabPane v-for="(item,index) in Tab.List" :key="index" :label="item.label"  :name="item.name"  :index="item.index">
                    <BusinessForm :currentPage="item.name"  v-if="item.name=='yhfzxz_jm'||item.name=='yhfzgz_jm'" ></BusinessForm>
                    <BusinessForm :currentPage="item.name" v-else ></BusinessForm>
                </TabPane>
            </Tabs>
            <Spin size="large" fix v-if="SpinShow"></Spin>
        </div>
        <div class="footerArea">© 2020 马鞍山首创水务有限责任公司 All Rights Reserved</div>
    </div>
</template>

<script>
    import BusinessForm from './BusinessForm';
    // import BusinessExpandingForm from './BusinessExpandingForm';
    export default {
        name: 'BusinessLayout',
        components:{
              BusinessForm,
              // BusinessExpandingForm
        },
        data() {
            return {
                Tab:{
                    CurrentName:"ghsq_jm",
                    List:[
                        {name:"yhfzxz_jm",label:"接水申请",index:1},
                        {name:"ghsq_jm",label:"水表过户",index:2},
                        {name:"zxsq_jm",label:"水表销户",index:3},
                        {name:"jthd_jm",label:"阶梯人口变更",index:4},
                        {name:"zlbg_jm",label:"用户资料变更",index:5},
                        {name:"ysxz_jm",label:"用水性质变更",index:6}
                    ],
                },
                SpinShow:false,
            }
        },
        created() {
           this.Tab.CurrentName=this.$route.query.currentPage;
        },
        mounted(){

        },
        methods: {

        }
    }
</script>

<style scoped>
    h3{
        font-size: 14px;
    }
    .ivu-row{
        margin-left: 16px!important;
        margin-right: 16px!important;
    }
    .txtClass h3{
        padding:10px 0
    }
    .contentArea .iconBlock{
        width:8px;
        height:20px;
        background:#f90;
        position: absolute;
        top:20px;
        left:0
    }
    .contentArea h3{
        text-align: left;
        font-size:18px;
    }
    .txtClass .iconBlock{
        width:8px;
        height:20px;
        background:#2EB4E9;
        position: absolute;
        top:10px;
        left:0
    }
    .submitBtn{
        padding-top:10px;
    }
    .formArea{
        padding-top:30px;
    }
    .ivu-form-item{
        text-align: left!important;
    }
    /*上传图片*/
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    .explainTXT{
        text-align: left
    }
    .explainTXT p{
        line-height:32px;
    }

</style>
